import { initSegmentedControl } from '../../../../../../design/proto-kit/src/components/control-segmente/control-segmente.js';
import { renderList } from './modules/list.js';
import { renderMap } from './modules/map.js';
import { t } from './modules/dictionary.js';

const DATA_URL = '/themes/sources-energie/energie-eolienne/parcs-eoliens/data/parcs-eoliens.json';
const ITEMS_PER_PAGE = 7;

async function init() {
  // const countEl = document.querySelector('.js-count');
  const listEl = document.querySelector('.js-list');
  const mapEl = document.querySelector('.js-map');
  const segmentedControlEl = document.querySelector('.js-segmented-control');
  const regions = [...document.querySelectorAll('.js-regions [data-region-value]')];

  if (mapEl) mapEl.setAttribute('aria-label', t('map.ariaLabel'));

  let map = null;

  /**
   * Toggle map/list regions from selected segmented-control value.
   * Uses native radio semantics (no tab roles).
   * @param {string} value
   */
  const onViewChange = (value) => {
    if (regions.length === 0) return;

    regions.forEach((region) => {
      const regionValue = region.getAttribute('data-region-value');
      region.hidden = regionValue !== value;
    });

    if (map) map.refresh();
  };

  if (segmentedControlEl && regions.length > 0) {
    initSegmentedControl({
      el: segmentedControlEl,
      param: t('view.param'),
      onInit: (value) => { onViewChange(value); },
      onChange: (value) => { onViewChange(value); },
    });
  }

  try {
    const response = await fetch(DATA_URL);
    const items = await response.json();

    // if (countEl) countEl.textContent = `${items.length}\u00a0${t('count.unit')(items.length)}`;
    if (listEl) renderList({ el: listEl, items, itemsPerPage: ITEMS_PER_PAGE });
    if (mapEl) map = renderMap({ el: mapEl, items });
  } catch (err) {
    console.error('Erreur lors du chargement des données :', err);
  }
}

document.addEventListener('DOMContentLoaded', init);
